var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ml-3" },
    [
      _c("section-title", { attrs: { "has-line": true, title: _vm.title } }),
      !_vm.canAdd && _vm.value.length == 0 && !_vm.disabled
        ? _c(
            "div",
            {
              staticClass:
                "row bg-secondary-3 rounded p-3 mb-2 d-flex justify-content-center",
              on: { click: _vm.openAttachment }
            },
            [_vm._m(0)]
          )
        : _vm._e(),
      !_vm.canAdd && _vm.value.length == 0 && _vm.disabled
        ? _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-center mt-5 py-5"
            },
            [_vm._m(1)]
          )
        : _vm._e(),
      _c("div", {}, [
        _vm.canAdd
          ? _c(
              "div",
              [
                _c(
                  "validation-observer",
                  {
                    ref: "documentObserver",
                    staticClass: "row mx-2 bg-secondary-3 p-3",
                    attrs: { tag: "div" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-4 col-sm-6" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        id: "ddlDocumentType",
                                        "custom-error-msg":
                                          "Favor seleccionar tipo de documento.",
                                        disabled: _vm.disabled,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        label: "Tipo de Documento",
                                        options: _vm.documentTypes
                                      },
                                      model: {
                                        value: _vm.documentType,
                                        callback: function($$v) {
                                          _vm.documentType = $$v
                                        },
                                        expression: "documentType"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1200948836
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-4 col-sm-6" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-file-input", {
                                      ref: "fileUpload",
                                      attrs: {
                                        accept: _vm.file.allowedFiles,
                                        "custom-error-msg":
                                          "Favor seleccionar un documento.",
                                        "display-style": "normal",
                                        error: errors[0],
                                        label: "Documento:",
                                        "label-position": "left",
                                        "on-download": _vm.onDownloadFile,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.file.attachment,
                                        callback: function($$v) {
                                          _vm.$set(_vm.file, "attachment", $$v)
                                        },
                                        expression: "file.attachment"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            4214667675
                          )
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-md-4" }, [
                      _c(
                        "div",
                        { staticClass: "mt-4 text-right" },
                        [
                          _c(
                            "action-button",
                            {
                              attrs: {
                                id: "btnCancel",
                                i: "fas fa-times-circle",
                                variant: "outline-danger btn-cancel danger m-2"
                              },
                              on: {
                                click: () => (this.isAdding = !this.isAdding)
                              }
                            },
                            [_vm._v(" Cancelar ")]
                          ),
                          _c(
                            "action-button",
                            {
                              attrs: {
                                id: "btnAdd",
                                variant: "success pl-4 pr-4"
                              },
                              on: { click: _vm.onAdd }
                            },
                            [_vm._v(" Añadir ")]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm.value.length > 0
          ? _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "rounded mx-3 p-3" },
                  _vm._l(_vm.value, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: `document-row-${index}`,
                        staticClass: "row bg-secondary-3 mb-2 p-2"
                      },
                      [
                        _c("div", { staticClass: "col-md-4 col-sm-6" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "font-14 font-weight-normal color-secondary-6"
                            },
                            [_vm._v(" Tipo de Documento: ")]
                          ),
                          _c(
                            "p",
                            {
                              staticClass:
                                "font-16 font-weight-normal color-black"
                            },
                            [_vm._v(" " + _vm._s(item.documentType.name) + " ")]
                          )
                        ]),
                        _c("div", { staticClass: "col-md-4 col-sm-6" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "font-14 font-weight-normal color-secondary-6"
                            },
                            [_vm._v(" Archivo: ")]
                          ),
                          _c(
                            "p",
                            {
                              staticClass:
                                "font-16 font-weight-normal color-black"
                            },
                            [_vm._v(" " + _vm._s(item.fileName) + " ")]
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-4 text-center mt-3 d-none d-md-block d-lg-block"
                          },
                          [
                            _c("drop-down", {
                              attrs: {
                                "data-item": { item, index },
                                items: _vm.getActionItems()
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-12 text-center mt-3 d-none d-sm-block d-md-none"
                          },
                          _vm._l(
                            _vm.getActionItems().filter(f => f.visible),
                            function(action, indexAction) {
                              return _c(
                                "action-button",
                                {
                                  key: "actions_" + indexAction,
                                  attrs: {
                                    variant:
                                      "btn btn-md btn-block " + action.btnColor
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.methodHandle(
                                        action.click,
                                        index
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", { class: action.iconOutline }),
                                  _vm._v(" " + _vm._s(action.label) + " ")
                                ]
                              )
                            }
                          ),
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          : _vm._e(),
        !_vm.canAdd && _vm.value.length > 0 && !_vm.disabled
          ? _c(
              "div",
              { staticClass: "col-1 ml-auto" },
              [
                _c(
                  "action-button",
                  {
                    attrs: { variant: "success mr-2" },
                    on: { click: _vm.openAttachment }
                  },
                  [
                    _vm._v("   "),
                    _c("i", { staticClass: "fas fa-file-plus" }),
                    _vm._v(" Añadir ")
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-md-12 col-sm-6" }, [
        _c(
          "label",
          {
            staticClass:
              "form-control position-relative text-center mb-0 file-input-container"
          },
          [
            _c("label", { staticClass: "file-select" }, [
              _c("em", { staticClass: "fas fa-file-plus pr-4 text-green" }),
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(" Presione aquí para anejar documento ")
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "align-items-center d-flex" }, [
      _c("i", {
        staticClass: "fal big-icon mr-4 fa-folder-open text-gray-light"
      }),
      _c("span", { staticClass: "text-gray-light message" }, [
        _vm._v("No existen documentos")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }